import React, { useEffect } from "react";
import { colors } from "../../constants/theme";
import { useState } from "react";
import { products, services } from "../../constants/data";

const ProductsContainer = ({ slug }) => {
  const [activeItem, setActiveItem] = useState(null);

  useEffect(() => {
    // const tempActive = item?.menu_items?.find((item) => item.title === item[0].title);
    setActiveItem(products[0]);
  }, []);
  return (
    <>
      <div>
        {/* Line */}
        {/* Bottom Button */}
        <div className="md:mx-36 flex justify-center items-center flex-wrap mb-14">
          {products?.map((i, index) => (
            <div
              key={index}
              className={`flex items-center justify-center uppercase md:text-lg text-md py-8 md:w-[250px] w-[150px] md:h-[100px] h-[60px] border border-white text-center px-4 cursor-pointer hover:bg-pink-600  hover:text-white  ${
                i?.title === activeItem?.title
                  ? " bg-pink-600  text-white"
                  : " bg-zinc-100 text-black font-light"
              }`}
              onClick={() => {
                setActiveItem(i);
              }}
            >
              {i?.title}
            </div>
          ))}
        </div>
        {/* Line */}
        <div
          style={{ background: colors.blueColor }}
          className="h-[0.5px] md:w-[400px] w-full my-10 md:mx-auto"
        />
        {activeItem && (
          <div className="bg-zinc-100 md:mx-64 my-20 md:px-20 px-10 py-10">
            {/* Sub Header */}
            <h1 className="uppercase text-pink-600 font-bold py-5">
              {activeItem?.title}
            </h1>
            <p className="text-[14px] font-light text-left">
              {activeItem?.desc}
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default ProductsContainer;
